import {Modal, Typography} from '@yandex-delivery/blocks'
import {SafeHTML} from '@yandex-delivery/xss-defender'
import React from 'react'
import i18n from 'src/shared/i18n'

import {PromoBannerButton} from '../promo-banner-button'
import {classes} from './PromoBannerPopupScreen.classes'
import type {Props} from './PromoBannerPopupScreen.types'

const Base: React.FC<Props> = ({title, subtitle, lead_button, trail_button, isOpen, promoCode}) => {
  return (
    <Modal opened={isOpen}>
      <Modal.Header className={classes.header} hideClose title={title} />
      <Modal.Body className={classes.body}>
        <Typography group="normal" thickness="regular" variant="body2">
          <SafeHTML html={i18n.print(subtitle)} />
        </Typography>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Controls>
          <PromoBannerButton {...lead_button} promoCode={promoCode} />
          <PromoBannerButton {...trail_button} promoCode={promoCode} />
        </Modal.Footer.Controls>
      </Modal.Footer>
    </Modal>
  )
}

export const PromoBannerPopupScreen = React.memo(Base)
